export const chart_boxplot_upper_quartile_Fill = {
  "name": "--pf-v6-chart-boxplot--upper-quartile--Fill",
  "value": "#707070",
  "var": "var(--pf-v6-chart-boxplot--upper-quartile--Fill, #707070)"
};
export default chart_boxplot_upper_quartile_Fill;